// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibButton_old-container__xAs8Z {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibButton_old-container__xAs8Z.nibButton_wrap__QuC\\+4 {
  flex-wrap: wrap;
}
.nibButton_old-container__xAs8Z .nibButton_box__aiddR.nibButton_col__lUY-E {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibButton_old-container__xAs8Z .nibButton_box__aiddR.nibButton_col__lUY-E > div {
  width: 100%;
}
.nibButton_old-container__xAs8Z .nibButton_box__aiddR.nibButton_row__EVLTK {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibButton_old-container__xAs8Z form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibButton_old-container__xAs8Z form > .nibButton_box__aiddR.nibButton_col__lUY-E {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibButton_old-container__xAs8Z form > .nibButton_box__aiddR.nibButton_col__lUY-E {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibButton_old-container__xAs8Z, .nibButton_col__lUY-E, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibButton_old-container__xAs8Z, .nibButton_col__lUY-E, form {
    padding: 0px;
  }
}
.nibButton_text-overflow-hidden__tpvu\\+ {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibButton_icon__z9sev {
  color: var(--accent-color);
}

.nibButton_richtext-output-wrap__2Drch .nibButton_se-video-container__YILnL figure {
  padding-bottom: 0 !important;
}

.nibButton_btn__WFgis {
  position: relative;
  border: none;
  background-color: #2F2F2F;
  border: 2px solid var(--accent-color);
  border-radius: 4px;
  color: #fff;
  padding: 10px 20px;
  transition: box-shadow 0.5s ease;
  letter-spacing: 0.25px;
}
.nibButton_btn__WFgis, .nibButton_btn__WFgis > * {
  cursor: pointer;
}
.nibButton_btn__WFgis.nibButton_simple__6hx4A {
  text-transform: uppercase;
  font-weight: 400;
  color: var(--accent-color);
  border: none;
  letter-spacing: 1px;
}
.nibButton_btn__WFgis.nibButton_filled__yypti {
  color: #2F2F2F;
  background-color: var(--accent-color);
  text-transform: uppercase;
  text-align: right;
  border-radius: 0px;
  box-shadow: -5px 5px 10px 0px rgba(0, 0, 0, 0.35);
  letter-spacing: 1px;
  color: #000;
  font-weight: 400;
  padding-right: 0;
  border: none;
}
.nibButton_btn__WFgis.nibButton_filled__yypti:disabled {
  background-color: #757575;
  border-color: #757575;
  color: #cecece;
}
.nibButton_btn__WFgis.nibButton_small__CLvb0 {
  font-size: 14px;
  height: 40px;
}
.nibButton_btn__WFgis.nibButton_medium__waN8k {
  font-size: 16px;
  height: 50px;
}

.nibButton_loading__Am0yM {
  color: transparent !important;
}

.nibButton_loadingIndicator__oel9s {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -40%);
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibButton/nibButton.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,kBAAA;EAEA,YAAA;EACA,yBDUG;ECTH,qCAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EAEA,gCAAA;EACA,sBAAA;AA0EJ;AAzEI;EACI,eAAA;AA2ER;AA1EI;EACI,yBAAA;EACA,gBAAA;EACA,0BDDC;ECED,YAAA;EACA,mBAAA;AA4ER;AA3EI;EACI,cDPD;ECQC,qCDNC;ECOD,yBAAA;EAEA,iBAAA;EACA,kBAAA;EDpBN,iDAAA;ECsBM,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AA6ER;AA5EQ;EACI,yBAAA;EACA,qBAAA;EACA,cAAA;AA8EZ;AA7EI;EACI,eAAA;EACA,YAAA;AA+ER;AA9EI;EACI,eAAA;EACA,YAAA;AAgFR;;AA/EA;EACI,6BAAA;AAkFJ;;AAjFA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAoFJ","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../sass/settings'\n\n.btn\n    position: relative\n    // width: 100%\n    border: none\n    background-color: $main\n    border: 2px solid $accent\n    border-radius: 4px\n    color: #fff\n    padding: 10px 20px\n    // box-shadow: 0px 0px 10px 0px rgba(#000, .25)\n    transition: box-shadow .5s ease\n    letter-spacing: .25px\n    &, & > *\n        cursor: pointer\n    &.simple\n        text-transform: uppercase\n        font-weight: 400\n        color: $accent\n        border: none\n        letter-spacing: 1px\n    &.filled\n        color: $main\n        background-color: $accent\n        text-transform: uppercase\n        font-weight: 600\n        text-align: right\n        border-radius: 0px\n        +shadow()\n        letter-spacing: 1px\n        color: #000\n        font-weight: 400\n        padding-right: 0\n        border: none\n        &:disabled\n            background-color: #757575\n            border-color: #757575\n            color: #cecece\n    &.small\n        font-size: 14px\n        height: 40px\n    &.medium\n        font-size: 16px\n        height: 50px\n.loading\n    color: transparent !important\n.loadingIndicator\n    position: absolute\n    left: 50%\n    top: 50%\n    transform: translate(-50%,-40%)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibButton_old-container__xAs8Z`,
	"wrap": `nibButton_wrap__QuC+4`,
	"box": `nibButton_box__aiddR`,
	"col": `nibButton_col__lUY-E`,
	"row": `nibButton_row__EVLTK`,
	"text-overflow-hidden": `nibButton_text-overflow-hidden__tpvu+`,
	"icon": `nibButton_icon__z9sev`,
	"richtext-output-wrap": `nibButton_richtext-output-wrap__2Drch`,
	"se-video-container": `nibButton_se-video-container__YILnL`,
	"btn": `nibButton_btn__WFgis`,
	"simple": `nibButton_simple__6hx4A`,
	"filled": `nibButton_filled__yypti`,
	"small": `nibButton_small__CLvb0`,
	"medium": `nibButton_medium__waN8k`,
	"loading": `nibButton_loading__Am0yM`,
	"loadingIndicator": `nibButton_loadingIndicator__oel9s`
};
export default ___CSS_LOADER_EXPORT___;
